import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import {redirect} from '../../../v2/api/redirect';
import Translation from '../../../v2/lang/Translation';
import {getSettings, getSiteDataV2, isGuest} from '../../../v2/selectors/selectors';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

const useStyles = createUseStyles({
  buttons: {
    marginBottom: 20,
    '&:last-child': {
      marginBottom: 0,
    },
    
    [MediaQueries.phone]: {
      marginBottom: '0.5em',
    },
  },
});

export function AccountButtons(props) {
  const classes = useStyles();
  return (
    <>
      <Button
        id={`${props.prefixName}__continueShoppingButton`}
        className={classes.buttons}
        onClick={() => redirect.doRedirect(props.continueShoppingURL)}
        primary
        fullWidth
      >
        <Translation optionalExtension={props.siteCode}>btn.continue.shopping.text</Translation>
      </Button>
      
      {props.showAccountButton && (
        <Button
          id={`${props.prefixName}__yourAccountButton`}
          className={classes.buttons}
          onClick={() => redirect.doRedirect(props.yourAccountURL)}
          fullWidth
        >
          <Translation optionalExtension={props.siteCode}>btn.your.account.text</Translation>
        </Button>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  const siteDataV2 = getSiteDataV2(state);
  const settings = getSettings(state);
  
  return {
    showAccountButton: !isGuest(state),
    continueShoppingURL: settings.continue_shopping_url || siteDataV2.unsecureHomePageUrl,
    yourAccountURL: settings.your_account_url || `${siteDataV2.unsecureHomePageUrl}accountHome.account`,
    siteCode: siteDataV2.siteCode,
  };
};

AccountButtons.propTypes = {
  siteCode: PropTypes.string.isRequired,
  prefixName: PropTypes.string.isRequired,
  showAccountButton: PropTypes.bool.isRequired,
  continueShoppingURL: PropTypes.string.isRequired,
  yourAccountURL: PropTypes.string.isRequired,
};

export default connect(
  mapStateToProps,
)(AccountButtons);
